import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.downloadPDFContract.loading;
export const selectErrorMessage = (state: RootState) =>
  state.downloadPDFContract.error;
export const downloadPDFContractDataResponse = (state: RootState) =>
  state.downloadPDFContract.downloadPDFContractResponse;
